import InputData from "./InputData";
import ButtonIconH from "./ButtonIconH";
import { useEffect, useState } from "react";
import { focusElement, selectedOptic, userData } from "../js/utils";
import { post } from "../js/post";

export default function Decentration({
  patientId,
  calibre,
  puente,
  glassesType,
  onAccept,
}) {
  const [lastOptometry, setLastOptometry] = useState(null);
  const [data, setData] = useState({
    calibre: calibre,
    puente: puente,
    npder: "",
    npizq: "",
    interpupilar: "",
    oi: "",
    od: "",
    ao: "",
  });

  const getLastOptometry = async () => {
    let response = await post("/ObtenerUltimaOptometriaBasica.php", {
      token: userData.token,
      optica: selectedOptic.id,
      idPaciente: patientId,
      tipoFicha: "Gafas",
    });
    if (response.idOptometria) {
      setLastOptometry(response);
      setData((prev) => ({
        ...prev,
        npder:
          glassesType === "CE"
            ? response.nasopupilar_cerca_d
            : response.nasopupilar_lejos_d,
        npizq:
          glassesType === "CE"
            ? response.nasopupilar_cerca_i
            : response.nasopupilar_lejos_i,
        interpupilar:
          glassesType === "CE"
            ? response.interpupilar_cerca
            : response.interpupilar_lejos,
      }));
    }
  };

  const calculateDecentration = () => {
    setData((prev) => ({
      ...prev,
      od:
        (parseInt(prev.calibre) + parseInt(prev.puente)) / 2 -
          parseFloat(prev.npder) || "",
      oi:
        (parseInt(prev.calibre) + parseInt(prev.puente)) / 2 -
          parseFloat(prev.npizq) || "",
      ao:
        parseInt(prev.calibre) +
          parseInt(prev.puente) -
          parseFloat(prev.interpupilar) || "",
    }));
  };

  useEffect(() => {
    getLastOptometry();
    focusElement(140);
  }, []);

  useEffect(() => {
    calculateDecentration();
  }, [data.npder, data.npizq, data.interpupilar, data.calibre, data.puente]);

  useEffect(() => {
    const npderValue = data.npder === "" ? 0 : parseFloat(data.npder);
    const npizqValue = data.npizq === "" ? 0 : parseFloat(data.npizq);

    setData((prev) => ({
      ...prev,
      interpupilar:
        data.npder === "" && data.npizq === "" ? "" : npderValue + npizqValue,
    }));
  }, [data.npder, data.npizq]);

  return (
    <div
      className="container-panel"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 10,
      }}
    >
      <div className="opt-table-content grid-9" id="decentration">
        <div className="cell combined-cells-3 opt-table-subtitle">
          Nasopupilar
        </div>
        <div className="cell combined-cells-3 opt-table-subtitle">Calibre</div>
        <div className="cell combined-cells-3 opt-table-subtitle">
          Descentramiento
        </div>
        <div className="cell cell-label cell-start-content">NPDer</div>
        <div className="cell">
          <InputData
            tabIndex={140}
            type="type-positive-float"
            size={0}
            input={data.npder}
            onChange={(e) => {
              setData((prev) => ({
                ...prev,
                npder: e,
              }));
            }}
          ></InputData>
        </div>
        <div className="cell"></div>
        <div className="cell">
          <InputData
            tabIndex={143}
            type="type-integer"
            size={0}
            input={data.calibre}
            onChange={(e) => {
              setData((prev) => ({
                ...prev,
                calibre: e,
              }));
            }}
          ></InputData>
        </div>
        <div className="cell cell-label">x</div>
        <div className="cell">
          <InputData
            tabIndex={144}
            type="type-integer"
            size={0}
            input={data.puente}
            onChange={(e) => {
              setData((prev) => ({
                ...prev,
                puente: e,
              }));
            }}
          ></InputData>
        </div>
        <div className="cell"></div>
        <div className="cell cell-label cell-start-content">OD</div>
        <div className="cell">
          <InputData
            type="type-float2"
            size={0}
            inactive={true}
            input={data.od}
            onChange={() => {}}
          ></InputData>
        </div>
        <div className="cell cell-label cell-start-content">Interpupilar</div>
        <div className="cell">
          <InputData
            tabIndex={142}
            type="type-positive-float"
            size={0}
            input={data.interpupilar}
            onChange={(e) => {
              setData((prev) => ({
                ...prev,
                interpupilar: e,
              }));
            }}
          ></InputData>
        </div>
        <div className="cell combined-cells-5"></div>
        <div className="cell cell-label cell-start-content">OI</div>
        <div className="cell">
          <InputData
            type="type-float2"
            size={0}
            inactive={true}
            input={data.oi}
            onChange={() => {}}
          ></InputData>
        </div>
        <div className="cell cell-label cell-start-content">NPIzq</div>
        <div className="cell">
          <InputData
            tabIndex={141}
            type="type-positive-float"
            size={0}
            input={data.npizq}
            onChange={(e) => {
              setData((prev) => ({
                ...prev,
                npizq: e,
              }));
            }}
          ></InputData>
        </div>
        <div className="cell combined-cells-5"></div>
        <div className="cell cell-label cell-start-content">AO</div>
        <div className="cell">
          <InputData
            type="type-float2"
            size={0}
            inactive={true}
            input={data.ao}
            onChange={() => {}}
          ></InputData>
        </div>
      </div>
      <div className="popup-buttons">
        <ButtonIconH
          text="Aceptar"
          onClick={() => {
            onAccept(data);
          }}
        ></ButtonIconH>
      </div>
    </div>
  );
}
